import { Route, Switch } from 'wouter';
import { LandingPage } from './routes/landing.js';
import { NotFoundPage } from './routes/not-found.js';
import { ManagerSignupPage } from './routes/manager-signup.js';
import { ManagerSigninPage } from './routes/manager-signin.js';
import { EmailVerificationPage } from './routes/email-verification.js';
import { CreateOrganizationPage } from './routes/create-organization.js';
import { ManagerDashboardPage } from './routes/manager-dashboard.js';
import { ExamAccessPage } from './routes/exam-access.js';
import { CandidateRegisterPage } from './routes/candidate-register.js';
import { ExamSessionPage } from './routes/exam-session.js';
import { ExamCreatePage } from './routes/exam-create.js';
import { ExamDetailPage } from './routes/exam-detail.js';
import { ExamsListPage } from './routes/exams-list.js';
import { ExamResultPage } from './routes/exam-result.js';
import { DemoPage } from './routes/demo.js';
import { MembersPage } from './routes/members.js';
import { InvitationAcceptPage } from './routes/invitation-accept.js';
import { ExamAttemptsPage } from './routes/exam-attempts.js';
import { ExamAttemptDetailPage } from './routes/exam-attempt-detail.js';
import { CertificateVerifyPage } from './routes/certificate-verify.js';
import { ExamTeamReportPage } from './routes/exam-team-report.js';
import { ExamDeltaPage } from './routes/exam-delta.js';
import { AdminDashboardPage } from './routes/admin-dashboard.js';
import { AdminQuestionsPage } from './routes/admin-questions.js';
import { AdminOrgsPage } from './routes/admin-orgs.js';
import { AdminOrgDetailPage } from './routes/admin-org-detail.js';
import { AdminUsersPage } from './routes/admin-users.js';
import { CohortPage } from './routes/cohort.js';
import { ExamInvitationPage } from './routes/exam-invitation.js';

export function App(): JSX.Element {
  return (
    <Switch>
      <Route path="/" component={LandingPage} />

      {/* Demo (Ghost) */}
      <Route path="/demo" component={DemoPage} />

      {/* Yönetici auth akışı */}
      <Route path="/yonetici/kayit" component={ManagerSignupPage} />
      <Route path="/yonetici/giris" component={ManagerSigninPage} />
      <Route path="/yonetici/dogrulama" component={EmailVerificationPage} />
      <Route path="/yonetici/firma-olustur" component={CreateOrganizationPage} />
      <Route path="/yonetici/dashboard" component={ManagerDashboardPage} />

      {/* Yönetici sınav yönetimi */}
      <Route path="/yonetici/sinavlar" component={ExamsListPage} />
      <Route path="/yonetici/sinavlar/yeni" component={ExamCreatePage} />
      <Route path="/yonetici/sinavlar/:id" component={ExamDetailPage} />
      <Route path="/yonetici/sinavlar/:id/adaylar" component={ExamAttemptsPage} />
      <Route path="/yonetici/sinavlar/:id/rapor" component={ExamTeamReportPage} />
      <Route path="/yonetici/sinavlar/:id/delta" component={ExamDeltaPage} />
      <Route
        path="/yonetici/sinavlar/:examId/aday/:attemptId"
        component={ExamAttemptDetailPage}
      />

      {/* Yönetici ekip yönetimi */}
      <Route path="/yonetici/davetler" component={MembersPage} />

      {/* Cohort analitiği */}
      <Route path="/yonetici/kohort" component={CohortPage} />

      {/* Davet kabul (public) */}
      <Route path="/davet/:token" component={InvitationAcceptPage} />

      {/* Sertifika doğrulama (public) */}
      <Route path="/sertifika/:certificateId" component={CertificateVerifyPage} />

      {/* BMU iç ekip — admin */}
      <Route path="/admin/dashboard" component={AdminDashboardPage} />
      <Route path="/admin/sorular" component={AdminQuestionsPage} />
      <Route path="/admin/firmalar" component={AdminOrgsPage} />
      <Route path="/admin/firmalar/:id" component={AdminOrgDetailPage} />
      <Route path="/admin/kullanicilar" component={AdminUsersPage} />

      {/* Aday sınav akışı */}
      <Route path="/sinav" component={ExamAccessPage} />
      <Route path="/sinav/kayit" component={CandidateRegisterPage} />
      <Route path="/sinav/davet/:token" component={ExamInvitationPage} />
      <Route path="/sinav/oturum/:attemptId" component={ExamSessionPage} />
      <Route path="/sinav/sonuc/:attemptId" component={ExamResultPage} />

      <Route component={NotFoundPage} />
    </Switch>
  );
}
